import { LeverageMargin } from '@ui/services/contract/hooks/PairsManagerFacet/types';

export const getMaxInputLeverageMarginNotionalUsd = ({
  leverage,
  leverageMargin,
  spreadPercentage,
}: {
  leverage: number;
  leverageMargin: LeverageMargin;
  spreadPercentage: number;
}) => {
  return leverageMargin.notionalUsdBuffered
    .multipliedBy(1 - spreadPercentage) // spread impacted notionalUsdBuffered
    .div(leverage);
};
